import Applet from "../Applet";
import EnlilDetailSubClass from "../../../components/EnlilDetailSubClass";

class SimpleSearchFormApplet extends Applet {
    state = {
        Name: "SimpleSearchFormApplet"
    };

    constructor(props) {
        super(props);

        this.state.Controls = props.controls;
        this.state.Actions = props.actions;
    };

    render() {
        return <EnlilDetailSubClass applet={this}
                                layout={this.state.Layout}
                                controls={this.state.Controls}
                                actions={this.state.Actions}
                                title="Organization"
                                enterpriseComponent={this.getEnterpriseComponent()}
                                action={this.props.defaultAction}
                                errorReportingMethod="RealTime" />;
    }
}

export default SimpleSearchFormApplet;
